import { useEffect, useState } from 'react';
import { Landmark, Loader2, Save } from 'lucide-react';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { toast } from 'sonner';
import api from '../../lib/api';

export const fetchBankSender = async () => {
    const { data } = await api.get('/admin/settings/bank-sender');
    return data;
};

export const BankSenderSettings = () => {
    const [name, setName] = useState('');
    const [current, setCurrent] = useState(null);
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        fetchBankSender().then((d) => { setCurrent(d); setName(d.name); }).catch(() => {});
    }, []);

    const save = async () => {
        const v = name.trim();
        if (v.length < 3) { toast.error('El remitente debe tener al menos 3 caracteres'); return; }
        setSaving(true);
        try {
            const { data } = await api.put('/admin/settings/bank-sender', { name: v });
            setCurrent(data); setName(data.name);
            toast.success('Remitente actualizado. Se aplicará a los próximos abonos.');
        } catch (e) {
            toast.error(e.response?.data?.detail || 'No se pudo guardar el remitente');
        } finally {
            setSaving(false);
        }
    };

    const dirty = current && name.trim() !== current.name;
    return (
        <div className="rounded-2xl bg-slate-900/70 border border-[#1973B8]/30 p-4 space-y-3" data-testid="bank-sender-settings">
            <div className="flex items-center gap-2">
                <Landmark className="w-4 h-4 text-[#7CB1E5]" />
                <p className="text-white font-semibold text-sm">Remitente del concepto de abono</p>
            </div>
            <p className="text-xs text-slate-400">
                Cada abono manual se registra como <span className="text-slate-200">TRANSFERENCIA BANCARIA A FAVOR DE: [NOMBRE]</span> · <span className="text-slate-200">Remitente: {name.trim() || '…'}</span>. El cambio aplica solo a abonos futuros.
            </p>
            <div className="flex flex-col sm:flex-row gap-2">
                <Input value={name} onChange={(e) => setName(e.target.value)} maxLength={80} placeholder="Nombre del banco remitente"
                    className="bg-slate-950 border-slate-800 text-white text-sm uppercase" data-testid="bank-sender-input" />
                <Button onClick={save} disabled={saving || !dirty} className="bg-[#1973B8] hover:bg-[#1973B8]/85 text-white" data-testid="bank-sender-save-btn">
                    {saving ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Save className="w-4 h-4 mr-2" />} Guardar
                </Button>
            </div>
            {current?.updated_at && (
                <p className="text-[10.5px] text-slate-600" data-testid="bank-sender-updated">
                    Última modificación: {new Date(current.updated_at).toLocaleString('es-ES')} · {current.updated_by}
                </p>
            )}
        </div>
    );
};
